var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12609_1031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 19.165C15.0617 19.165 19.165 15.0617 19.165 9.99996C19.165 4.93827 15.0617 0.834961 9.99996 0.834961C4.93827 0.834961 0.834961 4.93827 0.834961 9.99996C0.834961 15.0617 4.93827 19.165 9.99996 19.165Z",
    fill: "#240D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9598 14.75H7.6825C7.64369 14.75 7.60488 14.7396 7.56959 14.7189L4.57765 12.9089C4.47886 12.85 4.44358 12.722 4.50356 12.6251C4.54237 12.5628 4.61293 12.5213 4.69056 12.5247H12.9678C13.0066 12.5247 13.0454 12.5351 13.0807 12.5559L16.0727 14.3659C16.1714 14.4247 16.2067 14.5527 16.1467 14.6496C16.108 14.7119 16.0374 14.75 15.9598 14.75ZM7.74249 14.3313H15.2118L12.9113 12.9365H5.44207L7.74249 14.3313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4448 7.47548H7.16752C7.12871 7.47548 7.08989 7.4651 7.05461 7.44433L4.06621 5.63436C3.96389 5.57553 3.93213 5.44748 3.99211 5.35058C4.03092 5.28482 4.10149 5.24676 4.17911 5.25022H12.4563C12.4952 5.25022 12.534 5.2606 12.5693 5.28136L15.5612 7.09134C15.6635 7.15017 15.6953 7.27822 15.6353 7.37512C15.5929 7.44087 15.5224 7.47894 15.4448 7.47548ZM7.22751 7.06019H14.6968L12.3964 5.66551H4.92709L7.22751 7.06019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96985 8.72482C9.26417 8.72482 8.6866 9.38569 8.72792 10.0745C8.76674 10.7286 9.30301 11.2512 9.96985 11.2823C10.6746 11.2823 11.2824 10.7048 11.2753 9.99145C11.2606 9.29299 10.6647 8.72482 9.96985 8.72482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12609_1031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterlay);
export default __webpack_public_path__ + "static/media/interlay.19578ebafca6fa212068cbb6e75e0ac3.svg";
export { ForwardRef as ReactComponent };